<template>
  <div>
    <h4 class="use-text-subtitle mb-3">
      {{ $t('faq.topic') }}
    </h4>
    <ul class="topic-list">
      <li v-for="(item, index) in topics" :key="index">
        <a :href="`#${index}`">{{ item.header }}</a>
      </li>
    </ul>
  </div>
</template>

<style lang="scss" scoped>
@import './faq-style.scss';
</style>

<script>
export default {
  props: {
    topics: {
      type: Array,
      default: () => []
    }
  }
};
</script>
